const SECTION_SELECTOR = '[data-hero-slider]';
const READY_KEY = 'heroSliderReady';

const prefersReducedMotion = () => window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches;

function initSection( section ) {
	if ( section.dataset[ READY_KEY ] ) {
		return;
	}
	section.dataset[ READY_KEY ] = 'true';

	const tabs = [ ...section.querySelectorAll( '[data-hero-tab]' ) ];
	const panels = [ ...section.querySelectorAll( '[data-hero-panel]' ) ];
	const images = [ ...section.querySelectorAll( '[data-hero-image]' ) ];
	const delay = parseInt( section.dataset.autoplay, 10 ) * 1000;
	let current = 0;
	let timer = null;

	const activate = ( index, focus = false ) => {
		current = ( index + tabs.length ) % tabs.length;

		tabs.forEach( ( tab, i ) => {
			const isActive = i === current;
			tab.classList.toggle( 'is-active', isActive );
			tab.setAttribute( 'aria-selected', isActive ? 'true' : 'false' );
			tab.tabIndex = isActive ? 0 : -1;
			panels[ i ]?.classList.toggle( 'is-active', isActive );
			panels[ i ]?.toggleAttribute( 'inert', ! isActive );
			images[ i ]?.classList.toggle( 'is-active', isActive );
		} );

		if ( focus ) {
			tabs[ current ].focus();
		}
	};

	const stop = () => {
		window.clearInterval( timer );
		timer = null;
	};

	const start = () => {
		if ( ! delay || tabs.length < 2 || prefersReducedMotion() ) {
			return;
		}
		stop();
		timer = window.setInterval( () => activate( current + 1 ), delay );
	};

	tabs.forEach( ( tab, i ) => {
		tab.addEventListener( 'click', () => {
			activate( i );
			stop();
		} );

		tab.addEventListener( 'keydown', ( event ) => {
			const step = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[ event.key ];
			if ( step ) {
				event.preventDefault();
				activate( current + step, true );
				stop();
			}
		} );
	} );

	section.addEventListener( 'mouseenter', stop );
	section.addEventListener( 'mouseleave', start );
	section.addEventListener( 'focusin', stop );

	start();
}

const HeroSlider = {
	init( root = document ) {
		root.querySelectorAll( SECTION_SELECTOR ).forEach( initSection );
	},
};

export default HeroSlider;
